import type { ReactNode } from "react";

/** Servi depuis `public/`, donc référencé par son URL et non importé. */
const MG_LOGO = "/illustrations/mg-logo.svg";

/**
 * Le gabarit de toutes les pages publiques : le travail à gauche, l'identité à droite.
 *
 * Les proportions viennent de l'écran de connexion de main-app (7/12 – 5/12, coin
 * gauche arrondi à 32 px) : on hérite d'un design system au lieu d'en inventer un.
 *
 * LA HIÉRARCHIE EST CELLE DU CLIENT, PAS LA NÔTRE. L'en-tête appartient à l'école,
 * et Mentor Goal descend en pied de page, en petit. C'est ce que fait Stripe :
 * le marchand en haut, « Powered by Stripe » minuscule en bas. Une entreprise
 * répond à SON école, pas à notre outil ; nous mettre en premier lui faisait
 * croire l'inverse.
 *
 * Le panneau de droite disparaît sous 1024 px. Une image décorative qui mange la
 * moitié d'un écran de téléphone repousse le premier champ sous la ligne de flottaison.
 */
export function SplitLayout({
	illustration,
	masthead,
	children,
}: {
	illustration: string;
	/** L'identité de l'école, en tête du panneau gauche. Absente sur les écrans de code. */
	masthead?: ReactNode;
	children: ReactNode;
}) {
	return (
		<div className="flex h-dvh w-full bg-mg-surface">
			<div className="flex h-full w-full flex-col overflow-y-auto px-6 py-7 sm:px-10 lg:w-7/12 lg:px-14">
				{masthead ? <header className="shrink-0">{masthead}</header> : null}

				<div className="flex flex-1 flex-col justify-center py-8">
					<div className="mx-auto w-full max-w-lg">{children}</div>
				</div>

				<footer className="shrink-0 pt-6">
					<div className="mx-auto flex w-full max-w-lg items-center gap-2">
						<span className="t-caption text-mg-secondary">Propulsé par</span>
						<img src={MG_LOGO} alt="Mentor Goal" className="h-4 opacity-55" />
					</div>
				</footer>
			</div>

			<div className="hidden w-5/12 shrink-0 overflow-hidden rounded-l-[32px] lg:block">
				<img src={illustration} alt="" className="h-full w-full object-cover" />
			</div>
		</div>
	);
}
